'use client';

import { useEffect, useState } from 'react';

import { getCookie } from '@workspace/lib/utils/cookies';

import {
  ROUTE_PROTECTION_COOKIE,
  ROUTE_PROTECTION_STATES,
  type RouteProtectionState,
} from '@/constants/route-protection';

export function RouteProtectionSwitch() {
  const [selectedState, setSelectedState] =
    useState<RouteProtectionState>('on');

  useEffect(() => {
    const storedState = getCookie(ROUTE_PROTECTION_COOKIE);

    if (
      storedState &&
      ROUTE_PROTECTION_STATES.includes(storedState as RouteProtectionState)
    ) {
      setSelectedState(storedState as RouteProtectionState);
    }
  }, []);

  const handleStateSelect = (input: RouteProtectionState) => {
    setSelectedState(input);

    document.cookie = `${ROUTE_PROTECTION_COOKIE}=${input}; path=/; max-age=604800; SameSite=Lax; Secure`;
  };

  return (
    <div className='flex gap-x-4 p-4'>
      {ROUTE_PROTECTION_STATES.map((state) => {
        const id = `route-protection-${state}`;

        return (
          <div key={state} className='flex gap-x-2 text-base font-bold'>
            <input
              id={id}
              name='route_protection'
              type='radio'
              checked={selectedState === state}
              onChange={() => handleStateSelect(state)}
              className='cursor-pointer'
            />
            <label htmlFor={id} className='cursor-pointer'>
              {state.toUpperCase()}
            </label>
          </div>
        );
      })}
    </div>
  );
}
